export const AppEnum = {
  APP_SINDICO: {
    description: 'APPSINDICO',
    code: 1,
  },
  APP_PONTO: {
    description: 'APPPONTO',
    code: 2,
  },
  APP_PONTO_FIXO: {
    description: 'APPPONTOFIXO',
    code: 3,
  },
  APP_REKOGNIT: {
    description: 'REKOGNIT',
    code: 5,
  },
};
